var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Delete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1505",
    "data-name": "Rectangle 1505",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete",
    d: "M24.808,22H38.937c.488,0,.662,1.987.662,1.987H24.146S24.32,22,24.808,22Zm5.74-2.208H33.2a1.572,1.572,0,0,1,.883.883,1.572,1.572,0,0,1-.883.883H30.548a1.572,1.572,0,0,1-.883-.883A1.572,1.572,0,0,1,30.548,19.792Zm-4.415,4.857h11.48a.883.883,0,0,1,.883.883l-.883,13.246a.883.883,0,0,1-.883.883H27.016a.883.883,0,0,1-.883-.883L25.25,25.532A.883.883,0,0,1,26.133,24.648Zm1.325,1.766.221,11.48h1.545L29,26.415Zm3.532,0v11.48h1.766V26.415Zm3.753,0-.221,11.48h1.545l.221-11.48Z",
    transform: "translate(-20.146 -17.792)",
    fill: "#ff3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Delete);
export default __webpack_public_path__ + "static/media/icon-24-delete.8a996a34402014b9f2baf8b68b1943e3.svg";
export { ForwardRef as ReactComponent };